const fields = [
  'playId', // number
  'league', // string
  'season', // number
  'gameId', // number
  'playerName', // string
  'refereeName', // string
  'stadiumName', // string
  'finalScore', // string
  'scoreAtMomentOfPlay', // string
  'gameDate', // string
  'homeTeamName', // string
  'homeTeamLogo', // string
  'awayTeamName', // string
  'awayTeamLogo', // string
  'categoryId', // number
  'categoryName', // string
  'startTime', // number
  'endTime', // number
  'minuteOfPlay', // number
  'momentOfPlay', // number
  'videoUrl', // string
  // 'playTeam',
  // 'rivalTeam',
  // 'matchDayAbbreviation',
];
let fieldsObject = null;
let indexObject = null;

export function getPlayContentFields() {
  if (!fieldsObject) {
    fieldsObject = fields.reduce((accumulator, field, index) => {
      accumulator[index] = field;
      return accumulator;
    }, {});
  }
  return fieldsObject;
}

export function getPlayContentIndex() {
  if (!indexObject) {
    indexObject = fields.reduce((accumulator, field, index) => {
      accumulator[field] = index;
      return accumulator;
    }, {});
  }
  return indexObject;
}
